import React from 'react'
import SchedulesTable from 'components/Scheduling/SchedulesTable'

const AllSchedules = () => {
  return <SchedulesTable />
}

export default AllSchedules
